import { css } from '@fable/theme'
import { useState } from 'react'
import { useStats } from '../../../lib/ctx/stats'
import { OverflowMenu } from '../../shared'
import { StatsYearSelectorEmpty } from './StatsYearSelectorEmpty'
import { StatsYearSelectorContent } from './StatsYearSelectorContent'
import { StatsYearSelectorTrigger } from './StatsYearSelectorTrigger'

export const StatsYearSelector = () => {
  const [yearList, year] = useStats((s) => [s.yearList, s.year])
  const [open, setOpen] = useState(false)

  return (
    <div>
      <OverflowMenu
        dataTestId="stats-menu-button"
        open={open}
        setOpen={setOpen}
        wrapperStyles={css`
          top: 48px;
        `}
        containerStyles={css`
          padding-bottom: 8px;
          max-height: 250px;
        `}
        align="left"
        trigger={<StatsYearSelectorTrigger year={year} />}
        size="S"
      >
        {!yearList.length ? (
          <StatsYearSelectorEmpty />
        ) : (
          <StatsYearSelectorContent />
        )}
      </OverflowMenu>
    </div>
  )
}
